import { apiURL } from '../../../utilities/URLs'

export function DashboardResyncIDME() {
  const idMeURL = `${process.env.REACT_APP_IDME_API_DOMAIN}/oauth/authorize?client_id=${process.env.REACT_APP_IDME_CLIENT_ID}&redirect_uri=${apiURL}/idme&response_type=code&scope=openid%20http://idmanagement.gov/ns/assurance/ial/2/aal/2&state=resync`

  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-[#bceda6] font-robo'>
      <div className='w-full max-sm:scale-90 flex flex-col items-center'>
      <p className='font-bold text-3xl text-center mt-4'>Re-Sync Your ID.me Account</p>
        <div className='flex flex-col items-center gap-4 mt-10'>
          <p>We need to reconnect to your ID.me account to continue. Please click the button below to re-sync your account and restore access. We apologize for this delay.</p>
          <div className='flex justify-center w-full'>
            <button onClick={() => window.location.href = idMeURL}>
              <img className='w-56 h-11' src='https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg' />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}